"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoCarouselSwipeableContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactSwipeable = require("react-swipeable");
var _PhotoCarouselSwipeableContainer = require("./PhotoCarouselSwipeableContainer.styles");
// If we apply these properties via styled components, we will be destroying
// and building a new DOM element for every tiny change in swipingOffset as the
// state changes. This leads to a choppy animation and poor UX. We can get
// around this by applying the css to the element via the style property.
var getContainerStyle = function getContainerStyle(swipingOffset) {
  return swipingOffset ? {
    transform: "translate3d(" + swipingOffset + "%, 0,0)"
  } : {};
};

/**
 * An HOC that uses react-swipeable to make its children swipeable
 * using either touch or a mouse.
 *
 * @since 8.66.0
 */

var PhotoCarouselSwipeableContainer = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var onSwiping = _ref.onSwiping,
    onSwipedLeft = _ref.onSwipedLeft,
    onSwipedRight = _ref.onSwipedRight,
    onSwipedUp = _ref.onSwipedUp,
    onSwipedDown = _ref.onSwipedDown,
    shouldAnimateTranslations = _ref.shouldAnimateTranslations,
    swipingOffset = _ref.swipingOffset,
    children = _ref.children;
  var handlers = (0, _reactSwipeable.useSwipeable)({
    delta: 1,
    onSwipedLeft: onSwipedLeft,
    onSwipedRight: onSwipedRight,
    onSwipedUp: onSwipedUp,
    onSwipedDown: onSwipedDown,
    onSwiping: onSwiping
  });
  return /*#__PURE__*/_react.default.createElement(_PhotoCarouselSwipeableContainer.StyledPhotoCarouselSwipeableContainer, {
    ref: forwardedRef,
    shouldAnimateTranslations: shouldAnimateTranslations,
    style: getContainerStyle(swipingOffset)
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    id: "swipeable"
  }, handlers), children));
});
exports.PhotoCarouselSwipeableContainer = PhotoCarouselSwipeableContainer;
PhotoCarouselSwipeableContainer.displayName = 'PhotoCarouselSwipeableContainer';
PhotoCarouselSwipeableContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * An array of `PhotoCarouselSlide` components provided by `PhotoCarousel`.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Callback invoked after a down swipe.
   */
  onSwipedDown: _propTypes.default.func.isRequired,
  /**
   * Callback invoked after a left swipe.
   */
  onSwipedLeft: _propTypes.default.func.isRequired,
  /**
   * Callback invoked after a right swipe.
   */
  onSwipedRight: _propTypes.default.func.isRequired,
  /**
   * Callback invoked after an up swipe.
   */
  onSwipedUp: _propTypes.default.func.isRequired,
  /**
   * Callback invoked during swiping.
   */
  onSwiping: _propTypes.default.func.isRequired,
  /**
   * If true, the sliding animation is enabled.
   */
  shouldAnimateTranslations: _propTypes.default.bool,
  /**
   * Provided by `PhotoCarousel`. Represents the percent of the Property Card's
   * width the current touch event has travelled.
   */
  swipingOffset: _propTypes.default.number
} : {};
PhotoCarouselSwipeableContainer.defaultProps = {
  shouldAnimateTranslations: true,
  swipingOffset: 0
};